import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-fill text-background-50 text-base"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                  努努影院
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                努努影院致力于为观众提供高清流畅的电视剧在线观看体验，覆盖国产剧、韩剧、美剧、日剧、泰剧、动漫等海量资源，追剧首选平台。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                <a href="/category/guochan" className="hover:text-primary-400 transition-colors">热门分类</a>
              </h4>
              <ul className="space-y-2.5">
                {[
                  { to: '/category/guochan', label: '国产剧' },
                  { to: '/category/hanju', label: '韩剧' },
                  { to: '/category/meiju', label: '美剧' },
                  { to: '/category/riju', label: '日剧' },
                  { to: '/category/taiju', label: '泰剧' },
                  { to: '/category/dongman', label: '动漫' },
                ].map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系方式</Link></li>
                <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</Link></li>
                <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line text-background-500"></i>
                  <span>service@nunumovie.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-customer-service-2-line text-background-500"></i>
                  <span>在线客服 7×24小时</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-map-pin-line text-background-500"></i>
                  <span>北京市朝阳区</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; {new Date().getFullYear()} 努努影院 nunumovie.com 版权所有 | 本站资源仅供交流学习之用
              </p>
              <div className="flex items-center gap-4">
                <a href="/" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
                <a href="/" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
                <a href="/" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">版权声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}